import React, { Component } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Button
} from "reactstrap";
import axios from "axios";
import Constants from "../variables/Constants";
import { Link } from "react-router-dom";
import Notification from "components/Notification";
import Loader from "components/Loader";
class Batches extends Component {
  state = {
    gcvs: [],
    notifyStatus: false,
    notifyDelete: false,
    delLoader: 0,
    status: "",
    active: 1,
    btnIdArray: []
  };
  componentDidMount() {
    let btnIdArray = [];
    axios.get(Constants.getUrls.batches).then(resp => {
      console.log(resp.data);
      for (let i = 1; i <= resp.data.last_page; i++) {
        btnIdArray.push(i);
      }
      this.setState({
        gcvs: resp.data.data,
        btnIdArray
      });
    });
  }
  nextPageUrl = btnId => {
    let commonUrl = "https://core.vpaedu.com/api/getbatches?page=";
    axios.get(commonUrl + btnId).then(resp => {
      console.log(resp.data.data);
      this.setState({
        gcvs: resp.data.data,
        active: btnId
      });
    });
  };
  handleSelect = (e, id) => {
    this.setState(
      {
        [e.target.name]: e.target.value
      },
      () => {
        const payload = {
          status: this.state.status
        };
        axios.post(Constants.postUrls.gcvStatus + id, payload).then(res => {
          console.log(res);
          this.setState({
            notifyStatus: true
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        });
      }
    );
  };
  handleDelete = id => {
    this.setState({ delLoader: id });
    axios.post("https://core.vpaedu.com/api/batch/delete/" + id).then(res => {
      console.log(res);
      this.setState({
        notifyDelete: true
      });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
  };
  render() {
    return (
      <>
        <div className="content">
          {this.state.notifyStatus ? (
            <Notification
              title={"Status Changed Successfully"}
              duration={1500}
            />
          ) : null}
          {this.state.notifyDelete ? (
            <Notification title={"Deleted Successfully"} duration={1500} />
          ) : null}
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">Upcoming Batch Table</CardTitle>
                  <Link to="/admin/addbatch">
                    <Button className="" color="primary">
                      Add Upcoming Batch
                    </Button>
                  </Link>
                </CardHeader>
                <CardBody>
                  <Table responsive>
                    <thead className="text-primary">
                      <tr>
                        <th>Sr.No</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Image</th>
                        <th>Level</th>
                        {/* <th>Status</th> */}
                        <th>Actions</th>
                        {/* <th>Delete</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.gcvs.map((ageGroup, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{ageGroup.name}</td>
                          <td>
                            {ageGroup.description ? ageGroup.description : "NA"}
                          </td>
                          <td>
                            <img
                              width="80px"
                              src={Constants.imgUrl + ageGroup.image}
                              alt=""
                            />
                          </td>
                          <td>
                            {ageGroup.label ? ageGroup.label.label : "NA"}
                          </td>
                          {/* <td>
                            <select
                              className="btn-round btn-warning selectStyling"
                              name="status"
                              value={ageGroup.status}
                              onChange={e => this.handleSelect(e, ageGroup.id)}
                            >
                              <option value="enabled">Enabled</option>
                              <option value="disabled">Disabled</option>
                            </select>
                          </td> */}
                          <td>
                            <Link
                              to={{
                                pathname: "/admin/updatebatch/" + ageGroup.id,
                                state: { ageGroupData: ageGroup }
                              }}
                            >
                              <Button
                                className="btn-round"
                                color="primary"
                                type="submit"
                              >
                                Update
                              </Button>
                            </Link>
                            <Button
                              className="btn-round"
                              color="danger"
                              type="submit"
                              style={{ marginLeft: "10px" }}
                              onClick={() => {
                                this.handleDelete(ageGroup.id);
                              }}
                            >
                              {this.state.delLoader == ageGroup.id ? (
                                "Deleting..."
                              ) : (
                                "Delete"
                              )}
                            </Button>
                          </td>
                          {/* <td>
                                  <Button
                                    className="btn-round"
                                    color="primary"
                                    type="submit"
                                  >
                                    Delete
                                  </Button>
                                </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {this.state.gcvs.length === 0 ? (
                    <div>
                      <h6 style={{ textAlign: "center" }}>No Data Found</h6>
                    </div>
                  ) : null}
                  <div style={{ float: "right" }}>
                    {this.state.btnIdArray.map((btnId, index) => (
                      <button
                        style={{
                          backgroundColor:
                            this.state.active === index + 1
                              ? "#C0392B"
                              : "skyblue",
                          color: "white",
                          border: "none",
                          margin: "8px 2px",
                          padding: "4px 12px",
                          fontWeight: "bold"
                        }}
                        key={index}
                        onClick={() => {
                          this.nextPageUrl(btnId);
                        }}
                      >
                        {btnId}
                      </button>
                    ))}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default Batches;
